import styled from "styled-components"

export const Container = styled.section`
  position: fixed;
  z-index: 1000000;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  font-size: 1.6rem;
  line-height: 1.75rem;
  font-weight: 500;
  display: ${({ hideOnPageLoad }) => (hideOnPageLoad ? "none" : "block")};

  @media (min-width: 426px) {
    min-width: 28rem;
    height: auto;
    top: auto;
    bottom: 1.5rem;
    right: 1.5rem;
    font-size: 1.4rem;
    line-height: 1.525rem;
    max-width: 31rem;
    width: 31rem;
    border-radius: 0.6rem;
  }
`

export const Form = styled.form`
  padding: 0rem 1.7rem 0rem 2rem;
  background-color: white;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  @media (min-width: 426px) {
    height: ${({ displayError, formHeight }) => (displayError ? `${formHeight}px` : "auto")};
    border-bottom-right-radius: 0.6rem;
    border-bottom-left-radius: 0.6rem;
  }
`

export const Label = styled.label`
  padding: 1.7rem 0rem 0rem;
  margin-bottom: 1.4rem;

  @media (min-width: 426px) {
    padding: 1.3rem 0rem 0rem;
    margin-bottom: 1rem;
  }
`

export const SmallLabel = styled.p`
  display: inline;
  font-size: 1.2rem;
  margin-left: 0.5rem;

  @media (min-width: 426px) {
    font-size: 1rem;
  }
`

export const NoteInput = styled.textarea`
  font-family: "Maax";
  height: 9rem;
  border: 0.1rem solid lightgrey;
  padding: 0.8rem;
  font-size: 1.6rem;
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  border-radius: 0.3rem;
  height: 14rem;
  min-height: 14rem;
  resize: none;

  ${({ empty }) =>
    empty &&
    `
    border-color: red;
  `}

  @media (min-width: 426px) {
    height: 9rem;
    min-height: 9rem;
  }
`
export const Input = styled.input`
  padding: 0.8rem;
  font-size: 1.6rem;
  width: 100%;
  height: 4rem;
  border: 0.1rem solid lightgrey;
  border-radius: 0.3rem;
  ${({ empty }) =>
    empty &&
    `
    border-color: red;
  `}

  @media (min-width: 426px) {
    height: auto;
  }

  &[type="submit"] {
    background: ${({ theme, primary }) =>
      primary ? theme.component.cta : theme.component.ctaSecondary};
    color: ${({ theme }) => theme.colors.text.alternate};

    ${({ theme }) =>
      theme.component.isDarkBackground &&
      `
      background-color: ${theme.component.ctaInverted};
      color: ${theme.colors.text.primary};
    `}

    appearance: none; /* iOS */

    cursor: pointer;
    border: 0;
    padding: 1.4rem 2.7rem;
    font-size: 1.4rem;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.2rem;
    width: 100%;
    height: auto;
    background-color: #eb591a;
    border-radius: 3rem;
    margin: 2rem 0 0rem;

    ${({ disabled }) =>
      disabled &&
      `
    pointer-events: none; 
    cursor: not-allowed;
    opacity: 0.5;
    `}

    @media (min-width: 426px) {
      margin: 1rem 0 3.5rem;
      width: auto;
    }
  }
`
export const HeaderContainer = styled.div`
  display: flex;
  justify-content: center;
  background-color: #426f68;
  min-height: 4.1rem;
  color: white;
  align-items: center;

  @media (min-width: 426px) {
    border-top-right-radius: 0.6rem;
    border-top-left-radius: 0.6rem;
  }
`

export const CloseIconButton = styled.div`
  position: absolute;
  top: 1.4rem;
  right: 2rem;
  cursor: pointer;
  height: 1.5rem;
  width: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const CloseIcon = styled.div`
  background-color: white;
  border: 0.08rem solid white;
  width: 1.7rem;

  @media (min-width: 426px) {
    width: 1.2rem;
  }
`

export const Error = styled(Label)`
  color: red;
  line-height: 1.5rem;
  margin-bottom: 0;

  @media (min-width: 426px) {
    position: relative;
    bottom: 3rem;
    font-size: 1.4rem;
    padding: 0.5rem 0 0;
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const Title = styled.div`
  text-align: center;
  padding: 1rem 4.6rem;
  line-height: 1.7rem;
`

export const Success = styled.div`
  color: green;
  font-size: 1.6rem;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: 426px) {
    ${({ height }) => height && `height: ${height}px;`}
  }
`
